export const GET_USER_INFO_REQUEST = '@profile/GET_USER_INFO_REQUEST';
export const GET_USER_INFO_SUCCESS = '@profile/GET_USER_INFO_SUCCESS';
export const GET_USER_INFO_FAILURE = '@profile/GET_USER_INFO_FAILURE';

export const SET_USER_INFO_REQUEST = '@profile/SET_USER_INFO_REQUEST';
export const SET_USER_INFO_SUCCESS = '@profile/SET_USER_INFO_SUCCESS';
export const SET_USER_INFO_FAILURE = '@profile/SET_USER_INFO_FAILURE';
